// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultStaffPersonasMappingPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultStaffPersonasMappingFilter = {
	$skip: defaultStaffPersonasMappingPagination.$skip,
	$limit: defaultStaffPersonasMappingPagination.$limit,
};

export default {
	namespaced: true,
	state: {
		staffPersonasMappings: [],
		staffPersonasMappingFilter: defaultStaffPersonasMappingFilter,
		staffPersonasMappingPagination: defaultStaffPersonasMappingPagination,
		careLocations: [],
	},
	getters: {
		staffPersonasMappingPage: (state) => {
			const { $limit, $skip } = state.staffPersonasMappingPagination;
			return $skip / $limit + 1;
		},
		staffPersonasMappings: (state) => state.staffPersonasMappings,
	},
	mutations: {
		SET_STAFF_PERSONAS_MAPPINGS: (state, staffPersonasMappings) => { state.staffPersonasMappings = staffPersonasMappings; },
		SET_STAFF_PERSONAS_MAPPING_FILTER: (state, filter) => { state.staffPersonasMappingFilter = { ...state.staffPersonasMappingFilter, ...filter }; },
		SET_DEFAULT_STAFF_PERSONAS_MAPPING_FILTER: (state, filter) => { state.staffPersonasMappingFilter = { ...filter, ...defaultStaffPersonasMappingFilter }; },
		SET_STAFF_PERSONAS_MAPPING_PAGINATION: (state, data) => { state.staffPersonasMappingPagination = { ...state.staffPersonasMappingPagination, ...data }; },
		SET_CARE_LOCATIONS: (state, careLocations) => { state.careLocations = careLocations; },

	},
	actions: {
		loadStaffPersonasMappings: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/persona-mappings';
			const results = await feathersClient.service(url).find({ query: {
				 fields: ['jobTitle', 'trustId', 'careSpecialities', 'staffPersonas', 'careLocation'],
				  ...filter,
				  $role: rootGetters.currentUserRole,
				 },
				 });
			commit('SET_STAFF_PERSONAS_MAPPINGS', results.data);
			commit('SET_STAFF_PERSONAS_MAPPING_PAGINATION', { total: results.total });
			return results;
		},
		setStaffPersonasMappingFilter: ({ commit }, filter) => {
			commit('SET_STAFF_PERSONAS_MAPPING_FILTER', filter);
		},
		setDefaultStaffPersonasMappingFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_STAFF_PERSONAS_MAPPING_FILTER', filter);
		},
		setStaffPersonasMappingPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.staffPersonasMappingPagination.$limit;
			commit('SET_STAFF_PERSONAS_MAPPING_PAGINATION', { $skip });
			commit('SET_STAFF_PERSONAS_MAPPING_FILTER', { $skip });
		},
		searchStaffPersonas: async ({ rootGetters }, filter) => {
			const url = '/api/v3/personas';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $paginate: false, category: 'SHIFT', ...filter } });
			return results;
		},
		addStaffPersonasMapping: async ({ rootGetters }, data) => {
			const url = '/api/v3/persona-mappings';
			const results = await feathersClient.service(url).create(data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		addMappedPersona: async ({ rootGetters }, data) => {
			const url = '/api/v3/mapped-personas';
			const results = await feathersClient.service(url).create(data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteMappedPersonaMain: async ({ rootGetters }, filter) => {
			const url = '/api/v3/mapped-personas';
			const results = await feathersClient.service(url).remove(null, { query: { ...filter } });
			return results;
		},
		deleteStaffPersonasMapping: async ({ rootGetters }, filter) => {
			const url = '/api/v3/persona-mappings';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		getStaffPersonasMappingById: async ({ rootGetters }, data) => {
			const url = '/api/v3/persona-mappings';
			const results = await feathersClient.service(url).get(data.id, {
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['jobTitle', 'trustId', 'careSpecialities', 'staffPersonas', 'careLocation'],
				},
			});
			return results;
		},
		getBandByNumber: async (context, filter) => {
			filter.$paginate = false;
			const url = '/api/v3/band-types';
			const results = await feathersClient.service(url).find({ query: filter });
			return results;
		},
		updateStaffPersonasMapping: async ({ rootGetters }, data) => {
			const url = '/api/v3/persona-mappings';
			const results = await feathersClient.service(url).patch(data.id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		loadCareLocations: async ({ commit, rootGetters }) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $paginate: false } });
			commit('SET_CARE_LOCATIONS', results);
			return results;
		},
	},
};
